module.exports = "//public.getcloudapp.com/packs/media/images/integrations-54c4911099f798394670e37def7f438b.svg";